import BaseItem from "../BaseItem"
import {
  DATA_TYPE__JSON, DEFAULT_VALUE__CURRENT_MEMBER,
  DEFAULT_VALUE__MEMBER,
  DEFAULT_VALUE__RELATE_DATA,
  FORM_ITEM__MEMBER, FORM_ITEM__TABLE, FORM_STATUS__FILL
} from "../types"
import {defaultValueInit} from "../utils"
import store from '../../store'
import {isObject} from "../../../assets/js/Untis"

class Member extends BaseItem {
  constructor() {
    super()
    //选择范围
    this.chooseScope = {
      depart: [], // 部门
      member: [], // 成员
      role: [],    // 角色
      external: [], // 外部联系人
      externalTag: [] // 外部联系人标签
    }

    this.value = {
      depart: [], // 部门
      member: [], // 成员
      role: [],    // 角色
      external: [], // 外部联系人
      externalTag: [] // 外部联系人标签
    }

    this.chooseType = 1 // 0 单选 1 多选
    this.chooseCurrentOnly = 0 // 只可以选当前人员

    this.selectScope = {
      customList: [
        /*
        {
          key: uuid(),
          menuName: '',
          // * 部门控件内成员 DEP_FIELD, 指定部门内成员 FIXED_DEP, 指定角色内成员 FIXED_ROLE, 指定外部联系人标签内成员 FIXED_EXT_TAG,
          // * 指定成员 FIXED_MEMBER, 当前人所在部门内成员 CURRENT_DEP, 当前人所在部门主管 CURRENT_DEP_ADMIN,
          // * 成员控件所在部门内成员 MEMBER_FIELD_DEP, 成员控件所在部门主管 MEMBER_FIELD_DEP_ADMIN,
          // * 部门控件的部门主管 DEP_FIELD_ADMIN, 指定部门的部门主管 FIXED_DEP_ADMIN,
          type: '',
          fieldIdList: [], // 指定控件
          fixedScope: {
            depart: [], // 部门
            member: [], // 成员
            role: [],    // 角色
            external: [], // 外部联系人
            externalTag: [] // 外部联系人标签
          },
          includeNext: 'NO', // 包含部门下级
          includeSuperior: 'NO' // 包含部门上级
        }
        * */
      ],
      rules: [
        {
          key: 'member',
          name: '成员',
          memberShow: 'YES',
          extShow: 'YES'
        },
        {
          key: 'role',
          name: '角色',
          memberShow: 'YES',
          extShow: 'YES'
        },
        {
          key: 'tag',
          name: '外部联系人标签',
          memberShow: 'YES',
          extShow: 'YES'
        },
        {
          key: 'ext',
          name: '外部联系人',
          memberShow: 'YES',
          extShow: 'YES'
        },
      ]
    }
    this.defaultValue = {
      defaultType: ''
    }
  }

  get title() {
    return this.fieldTitle || Member._title
  }

   set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

Member._title = '人员选择'
Member.type = FORM_ITEM__MEMBER
Member.use = true
Member.icon = 'iconfont icon-chengyuan'

Member.prototype.type = Member.type
Member.prototype.dataType = DATA_TYPE__JSON
Member.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: "自定义",
    value: defaultValueInit(DEFAULT_VALUE__MEMBER)
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  }
]
Member.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }

  if (val && !isObject(val)) {
    console.error('the value of member is not an object --> ', val, this.dataId)
    this.value = {
      depart: [], // 部门
      member: [], // 成员
      role: [],    // 角色
      external: [], // 外部联系人
      externalTag: [] // 外部联系人标签
    }
    return
  }
  if (val &&
    ((val.member && val.member.length) ||
      (val.depart && val.depart.length) ||
      (val.external && val.external.length))) {
    this.value = val
    if (!this.value.member) this.value.member = []
    if (!this.value.depart) this.value.depart = []
    if (!this.value.role) this.value.role = []
    if (!this.value.external) this.value.external = []
    if (!this.value.externalTag) this.value.externalTag = []
  } else {
    this.value = {
      depart: [], // 部门
      member: [], // 成员
      role: [],    // 角色
      external: [], // 外部联系人
      externalTag: [] // 外部联系人标签
    }
    if (this.root.status !== FORM_STATUS__FILL) {
      return
    }
    if (this.defaultValue) {
      if (this.defaultValue.defaultType === DEFAULT_VALUE__MEMBER) {
        this.modified = true
        this.value = this.defaultValue.defaultMember
      } else if (this.defaultValue.defaultType === DEFAULT_VALUE__CURRENT_MEMBER) {
        this.modified = true
        // const members = store.state.userList.map(user => user.userId)
        if (store.getters.adminInfo.isMember) {
          this.value.member.push(store.getters.userId)
        } else {
          this.value.external.push(store.getters.userId)
        }
      }
    }
  }
}
Member.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不包含任意一个',
    method: 'nin'
  },
  {
    name: '包含任意一个',
    method: 'in'
  },
  {
    name: '同时包含',
    method: 'all'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
Member.prototype.getValue = function () {
  return this.value
}
Member.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.chooseScope) {
    this.chooseScope = opts.chooseScope
  }
  this.chooseType = opts.chooseType === 0 ? 0 : 1
  this.chooseCurrentOnly = opts.chooseCurrentOnly === 0 ? 0 : 1
  if (opts.selectScope) {
    this.selectScope = opts.selectScope
  }
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__MEMBER) {
      this.value = this.defaultValue.defaultMember
    }else if (opts.defaultValue.defaultType === DEFAULT_VALUE__CURRENT_MEMBER) {
      // const members = store.state.userList.map(user => user.userId)
      if (store.getters.adminInfo.isMember) {
        this.value.member.push(store.getters.userId)
      } else {
        this.value.external.push(store.getters.userId)
      }
    }
  }
}
Member.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    chooseScope: this.chooseScope,
    chooseType: this.chooseType,
    defaultValue: this.defaultValue,
    chooseCurrentOnly: this.chooseCurrentOnly,

    selectScope: this.selectScope
  }
}

Member.prototype.valueToString = function (value, opt = {}) {


  const depList = store.getters.depListMap,
    roleList = store.getters.roleListMap,
    userList = store.getters.userListMap,
    leaveMemberListMap = store.getters.leaveMemberListMap,
    extList = store.getters.extMap,
    leaveExternalMap = store.getters.leaveExternalMap,
    labelList = store.getters.extLabelMap

  value = value || this.value
  if (!value.depart) value.depart = []
  if (!value.role) value.role = []
  if (!value.member) value.member = []
  if (!value.external) value.external = []
  if (!value.externalTag) value.externalTag = []
  return [
    ...value.depart.map(depId => depList[depId] ? depList[depId].depName : ''),
    ...value.role.map(roleId => roleList[roleId] ? roleList[roleId].roleName : ''),
    ...value.member.map(userId => {
      if (userList[userId]) {
        return userList[userId].nickname
      } else if (leaveMemberListMap[userId]) {
        return leaveMemberListMap[userId].nickname
      } else {
        return  ''
      }
    }),
    ...value.external.map(userId => {
      if (extList[userId]) {
        return extList[userId].orgUserName
      } else if (leaveExternalMap[userId]) {
        return leaveExternalMap[userId].orgUserName
      } else {
        return  ''
      }
    }),
    ...value.externalTag.map(labelId => labelList[labelId] ? labelList[labelId].labelName : '')
  ].filter(item => !!item).join('、')
}
export default Member
